import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'
import { ElMessage } from 'element-plus'
import { createWebHashHistory } from 'vue-router'
import IndexView from '../views/IndexView.vue'

const routes = [
  {
    path: '/',
    name: 'index',
    component: IndexView,
    meta: {
      navbar: false,
      footer: false
    }
  },
  {
    path: '/home',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '../views/HomeView.vue'),
    meta: {
      navbar: true,
      footer: true
    }
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue'),
    meta: {
      navbar: true,
      footer: true
    }
  },
  {
    path: '/doctor',
    name: 'doctor',
    component: () => import(/* webpackChunkName: "doctor" */ '../views/DoctorView.vue'),
    meta: {
      navbar: true,
      footer: true
    }
  },
  {
    path: '/patient',
    name: 'patient',
    component: () => import(/* webpackChunkName: "patient" */ '../views/PatientView.vue'),
    meta: {
      navbar: true,
      footer: true
    }
  },
  {
    path: '/case',
    name: 'case',
    component: () => import(/* webpackChunkName: "case" */ '../views/CaseView.vue'),
    meta: {
      navbar: true,
      footer: true
    }
  },
  {
    path: '/report',
    name: 'report',
    component: () => import(/* webpackChunkName: "report" */ '../views/ReportView.vue'),
    meta: {
      navbar: true,
      footer: true
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue'),
    meta: {
      navbar: false,
      footer: true
    }
  },
  {
    path: '/info',
    name: 'info',
    component: () => import(/* webpackChunkName: "info" */ '../views/InfoView.vue'),
    meta: {
      navbar: true,
      footer: true
    }
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

// 全局前置守卫
router.beforeEach(async (to, from, next) => {
  const hasLocale = localStorage.getItem('locale')

  // if (to.path === '/' && hasLocale) {
  //   next('/home')
  //   return
  // }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLogin) {
      try {
        next()
      } catch (error) {
        console.error('验证登录状态失败:', error)
        ElMessage.error('验证登录状态失败')
        next('/home')
      }
    } else {
      ElMessage.warning('请先登录')
      next('/home')
    }
  } else {
    next()
  }
})

// 全局后置钩子
router.afterEach((to, from) => {
  // 可以在这里添加页面标题设置等
  console.log(`导航到: ${to.name}`)
})

export default router
